<template>
  <div class="foundation">
    <b-container
      class="foundation-container"
      fluid
      style="padding: 0px !important;"
    >
      <b-row class="no-gutters">
        <b-col class="d-flex flex-column" sm="5">
          <div class="foundation-header d-flex p-2">
            <level-dropdown></level-dropdown>

            <div
              class="align-middle d-flex align-items-center foundation-header-title"
            >
              Excercise {{ level.level }}: {{ level.title }}
            </div>
          </div>
          <div class="foundation-content">
            <h2>Introduction to Conditionals</h2>
            <h4>IF Statement</h4>
            <p>
              An <strong>IF statement</strong> helps computers make decisions
              about which code needs to execute, and under which conditions. For
              example, in the following the code in the IF statement will only
              execute if "myNumber" is more than 10
            </p>
            <img width="500" :src="`${publicPath}img/conditional_1.png`" />
            <p>
              So in this case, since myNumber is 5, the print function never be
              run.
            </p>
            <h4>IF ELSE Statement</h4>
            <p>
              An IF ELSE statement will specify not just only what code to
              execute when the condition is met, but also specify what is the
              code to execute if it is not met
            </p>
            <img
              class="mb-3"
              width="500"
              :src="`${publicPath}img/conditional_2.png`"
            />

            <h4>IF...ELSE IF...ELSE Statement</h4>
            <p>
              ELSE IF State statement add another condition to check when the
              first IF statement is false. For example:
            </p>
            <img
              class="mb-3"
              width="500"
              :src="`${publicPath}img/conditional_3.png`"
            />

            <div class="activity-header my-3">
              Activity
            </div>
            <p>
              Here we like to create a simple algorithm to check if someone is
              old enough to drive. The legal age to drive is 18.
            </p>
            <ol>
              <li>
                Create a variable called <span class="variable">myAge</span> and
                set it to some number
              </li>
              <li>
                Use a IF condition to check whether
                <span class="variable">myAge</span> is greater or equal to
                <span class="number">18</span> , if so, print a message
                <span class="string">I am old enough to drive!</span>
              </li>
            </ol>
          </div>
        </b-col>
        <b-col>
          <div class="foundation-actionbar d-flex justify-content-end">
            <b-button class="my-auto mr-2" @click="viewCode">
              View Code
            </b-button>
            <b-button
              variant="danger"
              class="my-auto mr-2"
              @click="resetWorkspace"
            >
              Reset
            </b-button>
            <b-button variant="primary" class="my-auto mr-2" @click="runCode">
              <font-awesome-icon
                class="mr-2"
                :icon="['fas', 'play']"
                style="color: white;"
              />Run
            </b-button>
          </div>
          <div id="blocklyDiv"></div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="showCode" title="JavaScript Code">
      <p class="my-4" style="white-space:pre-wrap;">
        {{ code }}
      </p>
    </b-modal>

    <b-modal
      v-model="showResultModal"
      title="Code result"
      @ok="onClickResultModalOk"
    >
      <div class="text-center">
        <h3>
          {{ isResultCorrect ? "Correct" : "Wrong" }}
        </h3>
        <p class="my-4" style="white-space:pre-wrap;">
          {{ resultMessage }}
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LevelDropdown from "@/components/LevelDropdown.vue";
import Blockly from "blockly";
import Interpreter from "js-interpreter";
import LevelRepository from "@/repositories/level-repository";

import UserServices from "@/services/user-services";
import { mapState } from "vuex";

export default {
  name: "level-two",

  components: {
    LevelDropdown
  },

  data() {
    return {
      id: this.$route.params.id,
      publicPath: process.env.BASE_URL,
      workspace: null,
      code: "",
      showCode: false,
      showResultModal: false,
      isResultCorrect: false,
      resultMessage: "",
      levels: [],
      level: {
        level: "",
        title: "",
        toolbox: null
      },
      result: {}
    };
  },

  mounted() {
    this.getLevels();
    this.getLevel();
    this.injectBlockly();
  },

  computed: {
    ...mapState(["user"])
  },

  methods: {
    initPage() {
      this.removeBlocklyInjection();
      this.getLevels();
      this.getLevel();
      this.injectBlockly();
    },

    injectBlockly() {
      this.workspace = Blockly.inject(document.getElementById("blocklyDiv"), {
        trashcan: true,
        toolbox: this.level.toolbox
      });

      if (this.level.workspace != undefined) {
        let workspaceBlock = Blockly.Xml.textToDom(this.level.workspace);
        Blockly.Xml.domToWorkspace(workspaceBlock, this.workspace);
      }
    },

    getLevel() {
      this.level = LevelRepository.getLevel(this.id);
    },

    getLevels() {
      this.levels = LevelRepository.getLevels();
    },

    viewCode() {
      this.code = Blockly.JavaScript.workspaceToCode(this.workspace);
      this.showCode = true;
    },

    resetWorkspace() {
      if (confirm("Are you sure you want to reset this question?")) {
        this.result = {};
        document.getElementById("blocklyDiv").innerHTML = "";
        this.injectBlockly();
      }
    },

    removeBlocklyInjection() {
      document.getElementById("blocklyDiv").innerHTML = "";
    },

    runCode() {
      let workspaceCode = Blockly.JavaScript.workspaceToCode(this.workspace);
      let code = this.appendCode(workspaceCode);
      let myInterpreter = new Interpreter(code, this.getInitApi());
      myInterpreter.run();
      this.checkResult(code);
    },

    appendCode(code) {
      code += "try {returnResult(myAge);} catch (err) {};";
      return code;
    },

    getInitApi() {
      const self = this;
      return (interpreter, scope) => {
        const wrapper = function(myAge) {
          self.result = {
            myAge: myAge
          };
        };
        interpreter.setProperty(
          scope,
          "returnResult",
          interpreter.createNativeFunction(wrapper)
        );
      };
    },

    checkResult(code) {
      const self = this;
      self.isResultCorrect = false;

      if (this.result.myAge == null) {
        this.resultMessage = "myAge variable is not set correctly";
      } else if (
        !code.includes("if (myAge > 17)") &&
        !code.includes("if (myAge >= 18)")
      ) {
        this.resultMessage = "If condition is not set correctly";
      } else if (!code.includes("alert('I am old enough to drive!')")) {
        this.resultMessage = "Print message is not set correctly";
      } else {
        self.isResultCorrect = true;
        self.resultMessage = "Great! Let move on to the next task.";
        if (this.user.uid != "") {
          this.updateUserDoneActivity();
        }
      }
      self.showResultModal = true;
    },

    onClickResultModalOk() {
      if (this.isResultCorrect) {
        let nextLevel = parseInt(this.id) + 1;
        this.$router.push("/foundation/" + nextLevel);
      } else {
        this.showResultModal = false;
      }
    },

    async updateUserDoneActivity() {
      await UserServices.updateUserDoneActivity(
        this.user.uid,
        this.level.firebaseId,
        "foundation"
      );
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    this.initPage();
    next();
  }
};
</script>

<style lang="less" scoped>
.foundation {
  &-header {
    background-color: rgb(255, 223, 137);

    &-title {
      line-height: 1.25rem;
      font-size: 1.25rem;
    }
  }

  &-content {
    padding: 15px;
    overflow: auto;
    height: calc(100vh - 120px);
  }

  &-actionbar {
    height: 54px;
  }
}

#blocklyDiv {
  height: calc(100vh - 110px);
  width: 100%;
}
</style>
